"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var _helpers = require("../../utils/helpers");
const rbgTheme = (0, _utils.getTheme)();
const theme = (0, _helpers.convertDesignTokenFromRGBToHex)(rbgTheme);
const colors = {
  primary: {
    blue: {
      '900': theme['palette-primary-900'],
      '800': theme['palette-primary-800'],
      '700': theme['palette-primary-700'],
      '600': theme['palette-primary-600'],
      '500': theme['palette-primary-500'],
      '400': theme['palette-primary-400'],
      '300': theme['palette-primary-300'],
      '200': theme['palette-primary-200'],
      '100': theme['palette-primary-100'],
      '50': theme['palette-primary-50']
    }
  },
  functional: {
    grey: {
      '900': theme['palette-functional-900'],
      '800': theme['palette-functional-800'],
      '700': theme['palette-functional-700'],
      '600': theme['palette-functional-600'],
      '500': theme['palette-functional-500'],
      '400': theme['palette-functional-400'],
      '300': theme['palette-functional-300'],
      '200': theme['palette-functional-200'],
      '100': theme['palette-functional-100'],
      '50': theme['palette-functional-50']
    }
  },
  secondary: {
    red: {
      '900': theme['palette-secondary-red-900'],
      '800': theme['palette-secondary-red-800'],
      '700': theme['palette-secondary-red-700'],
      '600': theme['palette-secondary-red-600'],
      '500': theme['palette-secondary-red-500'],
      '400': theme['palette-secondary-red-400'],
      '300': theme['palette-secondary-red-300'],
      '200': theme['palette-secondary-red-200'],
      '100': theme['palette-secondary-red-100'],
      '50': theme['palette-secondary-red-50']
    },
    teal: {
      '900': theme['palette-secondary-teal-900'],
      '800': theme['palette-secondary-teal-800'],
      '700': theme['palette-secondary-teal-700'],
      '600': theme['palette-secondary-teal-600'],
      '500': theme['palette-secondary-teal-500'],
      '400': theme['palette-secondary-teal-400'],
      '300': theme['palette-secondary-teal-300'],
      '200': theme['palette-secondary-teal-200'],
      '100': theme['palette-secondary-teal-100'],
      '50': theme['palette-secondary-teal-50']
    },
    citrus: {
      '900': theme['palette-secondary-citrus-900'],
      '800': theme['palette-secondary-citrus-800'],
      '700': theme['palette-secondary-citrus-700'],
      '600': theme['palette-secondary-citrus-600'],
      '500': theme['palette-secondary-citrus-500'],
      '400': theme['palette-secondary-citrus-400'],
      '300': theme['palette-secondary-citrus-300'],
      '200': theme['palette-secondary-citrus-200'],
      '100': theme['palette-secondary-citrus-100'],
      '50': theme['palette-secondary-citrus-50']
    },
    orange: {
      '900': theme['palette-secondary-orange-900'],
      '800': theme['palette-secondary-orange-800'],
      '700': theme['palette-secondary-orange-700'],
      '600': theme['palette-secondary-orange-600'],
      '500': theme['palette-secondary-orange-500'],
      '400': theme['palette-secondary-orange-400'],
      '300': theme['palette-secondary-orange-300'],
      '200': theme['palette-secondary-orange-200'],
      '100': theme['palette-secondary-orange-100'],
      '50': theme['palette-secondary-orange-50']
    }
  },
  feedback: {
    danger: {
      normal: theme['palette-feedback-danger-dark'],
      light: theme['palette-feedback-danger-light']
    },
    warning: {
      normal: theme['palette-feedback-warning-dark'],
      light: theme['palette-feedback-warning-light']
    },
    success: {
      normal: theme['palette-feedback-success-dark'],
      light: theme['palette-feedback-success-light']
    },
    info: {
      normal: theme['palette-feedback-info-dark'],
      light: theme['palette-feedback-info-light']
    }
  }
};
var _default = exports["default"] = colors;